module.exports = __webpack_public_path__ + "assets/img/heilongjiang.c7ea0c05.png";